// src/presence/PresenceService.tsx
import { useEffect } from "react";
import { updatePresence } from "./PresenceStore";
import { localRoomKey } from "./PresenceKeys";
import { PresenceUpdate } from "../types/socket-events";
import { useSocket } from "../hooks/socket";
import { useAuth } from "../hooks/auth";

export const PresenceService: React.FC = () => {
    const { token } = useAuth();
    const socket = useSocket(false);

    useEffect(() => {
        if (!token || !socket) return;

        const handler = (data: PresenceUpdate) => {
            const room = localRoomKey(
                data.scope.toLowerCase() as "company" | "flow" | "card",
                data.flowId,
                data.cardId
            );
            updatePresence(room, data.users);
        };

        socket.on("PRESENCE_UPDATE", handler);
        return () => {
            socket.off("PRESENCE_UPDATE", handler);
        };
    }, [token, socket]);

    return null;
};